<template>
  <div class="switcher">
    <label class="switcher__label">{{ label }}</label>
    <!-- note: coreui v3 CSwitch issue, v-model doesn't work -->

    <CSwitch :checked="value"
             @update:checked="handleChecked"
             v-bind="labelText"
             class="mx-1" color="dark" variant="outline" shape="pill" size="sm" />
  </div>
</template>

<script>
  export default {
    name: 'custom-switch',
    components: {},
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: 'Switch',
      },
      labelOn: {
        type: String,
        default: 'on',
      },
      labelOff: {
        type: String,
        default: 'off',
      },
    },
    data: function () {
      return {
        // internalValue: this.value,
        labelText: {
          labelOn: this.labelOn,
          labelOff: this.labelOff,
        },
      };
    },
    methods: {
      handleChecked(value) {
        // to emulate "v-model" behaviour
        this.$emit('input', value);
      },
    },
  }
</script>

<style scoped lang="scss">
.switcher {
  display: flex;
  align-items: center;
  margin-left: 5px;

  &__label {
    margin: 0 5px 0 0;
  }
}
</style>
